import * as Yup from "yup";
import { Field, Form, Formik, FieldArray } from "formik"
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getClassName } from "../../../utils";
import { Step } from "../../../components/Step/Step";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { questions, videos } from "../../../content/purpose/passion";
import { getPassionForm } from "../../../services/autofillService";
import { Companion } from "../../../components/Dialog/CompanionDialog";
import { ProgressLine } from "../../../components/Progress/Line";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import { setProgress } from "../../../store/progressSlice";
import { useDispatch } from "react-redux";
import { companionPurposePassion } from "../../../services/companionService";
import { Dots } from "../../../components/Loader/Dots";
import { submitPassion } from "../../../services/answersService";
import { getCompletedPayment } from "../../../services";

export const PurposePassion = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({
        thingsThatMadeYouProud: [
            {
                proud: ''
            },
        ],
        emergedFromCases: '',
        emergedFromSentence: ''
    });
    const [isCompanionOpen, setIsCompanionOpen] = useState(false);
    const [companionContent, setCompanionContent] = useState(null);
    const [isDotsLoading, setIsDotsLoading] = useState(false);
    const [hasCompletedPayment, setHasCompletedPayment] = useState(false);

    const handleSubmit = (values) => {
        setIsLoading(true);
        submitPassion(values).then(response => {
            setIsLoading(false);
            navigate("/flow/purpose/people")
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        });
    };

    const handleUpClick = () => {
        setActiveStep(activeStep - 1);
        if (activeStep === 2) {
            dispatch(setProgress(13))
        } else if (activeStep === 1) {
            dispatch(setProgress(10))
        }
    }

    const handleDownClick = (values) => {
        if (activeStep === 0) {
            // setIsDotsLoading(true);
            // companionPurposePassion("thingsThatMadeYouProud", values.thingsThatMadeYouProud).then(response => {
            //     const data = response.data;
            //     setIsCompanionOpen(true);
            //     setCompanionContent(data.thingsThatMadeYouProud);
            //     setIsDotsLoading(false);
            // }).catch(err => {
            //     console.error(err);
            // })
            dispatch(setProgress(13));
            if(hasCompletedPayment) {
                setActiveStep(activeStep + 1);
            } else {
                navigate("/flow/checkout")
            }
        } else {
            // setIsCompanionOpen(false);
            setActiveStep(activeStep + 1);
        }
    }

    const emergedFromCasesInformation = (values) => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">Things That Made You Proud:</p>
            <ul className="flex-1">
                {values.thingsThatMadeYouProud.map((el, index) => (
                    <li className="text-light-grey text-sm" key={index}>
                        {el.proud}
                    </li>
                ))}
            </ul>
        </div>
    )

    const emergedFromSentenceInformation = (values) => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">This emerged from those cases in one sentence:</p>
            <p className="text-light-grey text-sm">{values.emergedFromCases}</p>
        </div>
    );

    const handleConfirm = () => {
        setInitialValues({ ...initialValues, thingsThatMadeYouProud: companionContent })
        setIsCompanionOpen(false);
        setActiveStep(activeStep + 1);
    }

    const handleRefuse = () => {
        setIsCompanionOpen(false);
        setActiveStep(activeStep + 1);
    }

    const PassionSchema = Yup.object().shape({
        emergedFromCases: Yup.string().required('Required').matches(/(I am passionate about)/, "Please start the sentence with 'I am passionate about'."),
        emergedFromSentence: Yup.string().required('Required').matches(/(My passion is)/, "Please start the sentence with 'My passion is'."),
    })

    useEffect(() => {
        getPassionForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })

        getCompletedPayment().then(resp => {
            if(resp.data === 0) {
                setHasCompletedPayment(false);
            } else if (resp.data === 1) {
                setHasCompletedPayment(true)
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                    validationSchema={PassionSchema}
                >
                    {({ values, errors, touched }) => (
                        <>
                            <Form className="form">
                                <section className="flex flex-col items-center justify-center w-full h-full">
                                    <Step
                                        className={getClassName(0, activeStep)}
                                        question={questions.thingsThatMadeYouProud}
                                        url={videos.thingsThatMadeYouProudVideo.url}
                                    >
                                        <FieldArray name="thingsThatMadeYouProud">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.thingsThatMadeYouProud.length > 0 &&
                                                        values.thingsThatMadeYouProud.map((proud, index) => (
                                                            <>
                                                                <Field
                                                                    name={`thingsThatMadeYouProud.${index}.proud`}
                                                                    placeholder="Write what made you proud."
                                                                    className="has-border-bottom mt-3"
                                                                    key={index}
                                                                />
                                                            </>
                                                        ))

                                                    }
                                                    <AddMore onClick={() => push({ proud: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </Step>
                                    <Step
                                        className={getClassName(1, activeStep)}
                                        question={questions.emergedFromCases}
                                        url={videos.emergedFromCasesVideo.url}
                                        information={emergedFromCasesInformation(values)}
                                    >
                                        <Field
                                            name={`emergedFromCases`}
                                            placeholder="I am passionate about..."
                                            className="has-border-bottom mt-3"
                                        />
                                        {errors.emergedFromCases && touched.emergedFromCases && (
                                            <div className="text-xs text-[red] border border-solid border-red p-4 mt-2">{errors.emergedFromCases}</div>
                                        )}
                                    </Step>
                                    <Step
                                        className={getClassName(2, activeStep)}
                                        question={questions.emergedFromSentence}
                                        url={videos.emergedFromSentenceVideo.url}
                                        information={emergedFromSentenceInformation(values)}
                                    >
                                        <Field
                                            name={"emergedFromSentence"}
                                            placeholder="My passion is..."
                                            className="has-border-bottom mt-3"
                                        />
                                        {errors.emergedFromSentence && touched.emergedFromSentence && (
                                            <div className="text-xs text-[red] border border-solid border-red p-4 mt-2">{errors.emergedFromSentence}</div>
                                        )}
                                    </Step>
                                </section>
                                <Buttons link="/flow/purpose">
                                    <UpButton onClick={() => handleUpClick(values)} disabled={activeStep === 0} />
                                    {(activeStep === 2) ? (
                                        <button type="submit" className="btn yellow-cta">
                                            {isLoading ? <Oval
                                                height={30}
                                                width={50}
                                                color="black"
                                                secondaryColor="black"
                                            /> : (
                                                <span>
                                                    Next
                                                </span>
                                            )}
                                        </button>
                                    ) : (
                                        <DownButton onClick={() => handleDownClick(values)} disabled={activeStep === 2} />
                                    )}
                                </Buttons>
                            </Form>
                        </>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Purpose" />
            {/* <Companion open={isCompanionOpen}>
                <ul>
                    {companionContent && companionContent.map((el, index) => (
                        <li key={index} className="list-disc">{el.proud}</li>
                    ))}
                </ul>
                <div className="flex gap-2 justify-end">
                    <button onClick={handleConfirm}>Accept</button>
                    <button onClick={handleRefuse}>Refuse</button>
                </div>
            </Companion> */}
            <Dots isLoading={isDotsLoading} />
        </>
    )
}